import MainLayout, { MainLayoutProps } from './MainLayout';

export type { MainLayoutProps };
export default MainLayout;
